import templateUrl from './product-search.html';

export default {
  templateUrl,
  bindings: {
    animalTypes: '<',
    searchCriteria: '<',
    searchCriteriaChanged: '&',
    searchTypes: '<'
  },
  controller: class ProductSearchComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onChanges(changes) {
      if (changes.searchCriteria) {
        this.searchCriteria = Object.assign({}, this.searchCriteria);
      }
    }

    onChange() {
      this.searchCriteriaChanged(
        this.EventEmitter({
          searchCriteria: this.searchCriteria
        })
      );
    }

    selectedUserIngredientChanged($event) {
      this.searchCriteria.selectedUserIngredient = $event.selectedIngredient;
      this.onChange();
    }

    selectedSystemIngredientChanged($event) {
      this.searchCriteria.selectedSystemIngredient = $event.selectedIngredient;
      this.onChange();
    }

    selectedMemberChanged($event) {
      this.searchCriteria.selectedCompany = $event.company;
      this.onChange();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/products/product-search/product-search.component.js